import {OrderModel} from "../../../../../pages/shared/models/order/order-item.model";
import {ExistingOrderData} from "../styled";
import {ProductDetailsSummary} from "../../../../../pages/orders/order-popup/products/styled";
import BarekamText from "../../../../../pages/components/text";
import {Message, MessageSections} from "../../../../../pages/components/message/message";
import React from "react";

const ExistingOrderDetails = ({order, languageId}: {order: OrderModel, languageId: number}) => (
    <ExistingOrderData>
        <ProductDetailsSummary>
            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <BarekamText variant={"s"} bold color={'#087E38'}>
                    {order.products[0].name}
                </BarekamText>
            </div>

            <div style={{display: 'flex', justifyContent: 'space-between'}}>
                <div>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={'recipient'} sectionId={MessageSections.ORDERS}/>
                    </BarekamText>

                    <BarekamText variant={"m"} maxWidth={11}>
                        {`${order.recipient.firstName} ${order.recipient.lastName}`}
                    </BarekamText>
                </div>

                <div>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={'product_price'} sectionId={MessageSections.ORDERS}/>
                    </BarekamText>

                    <BarekamText variant={"m"}>
                        {order.products[0].price}
                    </BarekamText>
                </div>

                <div>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={'product_weight'} sectionId={MessageSections.ORDERS}/>
                    </BarekamText>

                    <BarekamText variant={"m"}>
                        {order.products[0]?.weight} {order.products[0]?.weightUnit?.name[languageId]}
                    </BarekamText>
                </div>

                <div>
                    <BarekamText variant={"s"} opaque>
                        <Message messageKey={'product_attachments'} sectionId={MessageSections.ORDERS}/>
                    </BarekamText>

                    <BarekamText variant={"m"}>
                        {
                            (order.products[0].invoice ? order.products[0].invoice.length : 0)
                            +
                            (order.products[0].image ? order.products[0].image.length : 0)
                        }
                    </BarekamText>
                </div>
            </div>
        </ProductDetailsSummary>
    </ExistingOrderData>
);

export default ExistingOrderDetails;